import MDEditor from '@uiw/react-md-editor'
import '@uiw/react-markdown-preview/markdown.css'
import '@uiw/react-md-editor/markdown-editor.css'

import './style.scss'

export interface MarkdownEditorProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  placeholder?: string
  height?: number
}

const MarkdownEditor = ({
  value,
  onChange,
  disabled = false,
  placeholder = 'No terms of use provided',
  height = 200,
}: MarkdownEditorProps) => {
  const content = value ?? ''

  if (disabled) {
    if (!content.trim()) {
      return (
        <div className="markdown-editor-view markdown-editor-view--empty">
          <span className="markdown-editor-placeholder">{placeholder}</span>
        </div>
      )
    }

    return (
      <div className="markdown-editor-view" data-color-mode="light">
        <div className="markdown-editor-view__inner wmde-markdown-var">
          <MDEditor.Markdown source={content} />
        </div>
      </div>
    )
  }

  return (
    <div className="markdown-editor-edit" data-color-mode="light">
      <MDEditor
        value={content}
        onChange={(val) => onChange?.(val ?? '')}
        preview="live"
        height={height}
        visibleDragbar={false}
        textareaProps={{ placeholder }}
      />
    </div>
  )
}

export default MarkdownEditor
